import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const AGENT_NAME = {
    ONBOARDING: 'onboarding',
    BUDGET_NEGOTIATION: 'budget_negotiation',
    CAMPAIGN_UNDERPERFORMING: 'campaign_underperforming',
    REPORTING_AGENT: 'reporting_agent',
};

export const MESSAGE_DIRECTION = {
    INCOMING: 'incoming',
    OUTGOING: 'outgoing',
};

export const reportAgentQuestionOptions = [
    {
        value: 'adjust-bidding-strategy',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.adjust.bidding.strategy"
                defaultMessage="Should I adjust my bidding strategy to increase conversions?"
            />
        ),
    },
    {
        value: 'top-performing-thumbnails',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.top.performing.thumbnails"
                defaultMessage="What are my top-performing ad thumbnails by platform and country in the last 14 days?"
            />
        ),
    },
    {
        value: 'account-mix-evolve',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.account.mix.evolve"
                defaultMessage="How did my account's site mix evolve in the last 7 days compared to the 7 days before?"
            />
        ),
    },
    {
        value: 'campaigns-cvr-decreasing',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.campaigns.cvr.decreasing"
                defaultMessage="Which segments showed a CVR decrease last week compared to the week before?"
            />
        ),
    },
    {
        value: 'most-frequent-ads-titles',
        label: (
            <FormattedMessage
                id="user.question.abby.report.assistant.most.frequent.ad.titles"
                defaultMessage="Which ad titles were most frequently used in my campaigns in the last week?"
            />
        ),
    },
];
